import { queryClient } from 'App';
import debounce from 'lodash/debounce';

import {
  appointmentQueryKeys,
  COMMUNICATION_LOGS_QUERY_KEY
} from 'lib/constants/queries/queryKeys';

export default debounce(() => {
  appointmentQueryKeys.forEach((key) => {
    queryClient.invalidateQueries({
      queryKey: [key],
      exact: false
    });
  });
  queryClient.invalidateQueries({ queryKey: [COMMUNICATION_LOGS_QUERY_KEY], exact: false });
}, 300);
